import { connect } from "react-redux";
import close_icon from "../../../../assets/icons/close.svg";
import Formulario from "../../../components/Formulario";
import { mapDispatchToProps, mapStateToProps } from "../../../../utils/config";
import { useEffect, useState } from "react";
import { municipiosDoEstado, acharMunicipio } from "../../../../utils/municipios";
import ControllerCadastro from "../../auth/Cadastro/controller";
import { estados } from "../../../../utils/data";
import ControllerConfiguracoes from "../Home/controller";
import AlertDialog from "../../../components/AlertDialog";
import Loading from "../../../components/Loading";

function AlterarEstadoModal({usuario, setUsuario, errors, setErrors, onClose}){

  const [loading, setLoading] = useState(false);
  const [dadosUsuario, setDadosUsuario] = useState({...usuario});
  const [showSuccess, setShowSuccess] = useState(false);

  // Dados antigos vem sem acento ("Espirito Santo"): casa com a lista oficial sem acento/caixa.
  const semAcento = (t) => String(t || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();
  const estadoAtual = estados.find((e) => semAcento(e) === semAcento(dadosUsuario.estado)) || "";

  const mudouEstado = !!estadoAtual && semAcento(estadoAtual) !== semAcento(usuario.estado);
  const [municipios, setMunicipios] = useState(null);
  const [erroCidade, setErroCidade] = useState("");
  const [cidade, setCidade] = useState("");

  useEffect(() => {
    let vivo = true;
    setMunicipios(null); setCidade(""); setErroCidade("");
    if (mudouEstado) municipiosDoEstado(estadoAtual).then((l) => { if (vivo) setMunicipios(l); });
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estadoAtual]);

  const controllerConfiguracoes = new ControllerConfiguracoes(usuario, errors, setErrors, setLoading, setUsuario);
  const controllerCadastro = new ControllerCadastro(dadosUsuario, errors, setDadosUsuario, setErrors, null);

  function salvar(e) {
    if (!estadoAtual) { setErrors({ ...errors, estado: "Escolha um estado da lista." }); return; }
    let novaCidade = dadosUsuario.cidade;
    if (mudouEstado) {
      // A cidade guardada pertence ao estado antigo: precisa escolher uma do novo.
      const oficial = municipios ? acharMunicipio(municipios, cidade) : (cidade.trim() || null);
      if (!oficial) { setErroCidade(`Escolha uma cidade de ${estadoAtual}.`); return; }
      novaCidade = oficial;
    }
    setErroCidade("");
    Object.assign(dadosUsuario, { estado: estadoAtual, cidade: novaCidade });
    controllerConfiguracoes.alterarDados(e, 'form-alterar-estado', dadosUsuario, setShowSuccess);
  }

  return(
    <div className="modal">
      {loading && <Loading/>}
      {showSuccess && (
        <AlertDialog
          titulo={`Estado alterado com sucesso!`}
          buttonText={"Ver meus dados"}
          buttonOnClick={onClose}
        />
      )}
      <div className="content-modal">
        <div className="top">
          <h3>Alterar Estado</h3>
          <button type="button" onClick={onClose}>
            <img src={close_icon} alt="Icone de fechar"/>
          </button>
        </div>

        <Formulario id="form-alterar-estado">
          
          <div className="form-group">
            <label htmlFor="estado">Estado</label>
            <select id="estado" name="estado" required value={estadoAtual} className={errors.estado && 'input-error'}
              onChange={(e)=>{ setDadosUsuario({...dadosUsuario, estado: e.target.value}); setErrors({...errors, estado: ""}); }}
            >
              <option value="" disabled>Escolha o seu estado</option>
              { estados.map((estado)=> <option key={estado} value={estado}>{estado}</option>) }
            </select>
            <span className="error">{errors.estado}</span>
          </div>

          {mudouEstado &&
            <div className="form-group">
              <label htmlFor="cidade-nova">Cidade em {estadoAtual}</label>
              <input type="text" id="cidade-nova" list="cidades-novo-estado" required autoComplete="off" placeholder={`Cidade de ${estadoAtual}`}
                value={cidade} onChange={(e)=>{ setCidade(e.target.value); setErroCidade(""); }} className={erroCidade && 'input-error'} />
              {municipios && <datalist id="cidades-novo-estado">{municipios.map((m) => <option key={m} value={m} />)}</datalist>}
              <span className="error">{erroCidade}</span>
            </div>
          }

          <div className="form-group">
          <button type="button" onClick={salvar}>Salvar</button> 
          </div>


              
        </Formulario>
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AlterarEstadoModal);